/* eslint-disable simple-import-sort/imports */
import * as React from 'react'
import { createBrowserHistory, Location } from 'history'
import { Sendum, Cognito } from '@sendum/core'
// eslint-disable-next-line import/no-unassigned-import
import 'react-select-search/style.css'

import { routes } from './routes'
import { Header } from './components/Header'
// eslint-disable-next-line import/no-unassigned-import
import './App.css'

const history = createBrowserHistory()
Sendum.setBrowserHistory(history)

const render = (location: Location): void =>
    void Cognito.cognitoContainerRender(location, { routes, header: <Header /> })
history.listen(l => render(l.location))
render(history.location)
